import { Button, TitleController } from '@pandiafi/design-system'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import routePath from '../../router/routePath'

import { ErrorPage } from 'views/ErrorPage'

export const NotFound: React.FC = () => {
  const { t } = useTranslation(['errors', 'titles', 'common'])
  const navigate = useNavigate()
  return (
    <TitleController title={t('titles:notFound')}>
      <ErrorPage
        title={t('errors:other.pageNotFound')}
        illustration="house-missing"
        message={t('common:additionalNotification')}
        action={
          <Button
            onClick={() => {
              navigate(routePath.root)
            }}
          >
            {t('common:backToHome')}
          </Button>
        }
      />
    </TitleController>
  )
}
